export const GENERIC_ERROR_MESSAGE = 'Something went wrong. Please try again.';

export const getResponseErrorTitle = async (
    response: Response,
    fallback = GENERIC_ERROR_MESSAGE,
): Promise<string> => {
    try {
        const data = (await response.json()) as { title?: string };
        return data.title ?? fallback;
    } catch {
        return fallback;
    }
};
